import { GetRecipeDiscussionDetailMeta, GetRecipeDiscussionDetailPayload } from 'types/store/GetRecipeDiscussionDetail';
import { createAsyncReducer } from 'utils/Redux';

import { getRecipeDiscussionDetailActions } from '../actions';

export default createAsyncReducer<GetRecipeDiscussionDetailMeta, GetRecipeDiscussionDetailPayload>(getRecipeDiscussionDetailActions);
